import Login from './components/login/Login'
import Navbar from 'src/components/navbar/Navbar'
import Profile from 'src/components/profile/Profile'
import SelectedOffersList from 'src/components/selected-offers-list/SelectedOffersList'
// import OffersDetailComponent from 'src/components/offers-detail-component/OffersDetailComponent'
// import CollectionComponent from 'src/components/collection-component/CollectionComponent'
import OffersComponent from 'src/components/offers-component/OffersComponent'
import PendingApproval from 'src/components/pending-approval/PendingApproval'
import PastApproval from 'src/components/past-approval/PastApproval'
import GraphSimulationNavBar from 'src/components/charts-simulation/GraphSimulationNavBar'
import Waterfall from 'src/components/charts-simulation/Waterfall'
import Simulation from 'src/components/charts-simulation/Simulation'
import PastTrends from 'src/components/charts-simulation/PastTrends'
import FileUpload from 'src/components/file-upload/FileUpload'

export const routes = [
  {
    path: '',
    name: 'login',
    component: Login,
    beforeEnter: (to, from, next) => {
      if (
        JSON.parse(
          localStorage.getItem('Parse/74835-54897-3473865-437684/currentUser')
        )
      ) {
        next({name: 'PendingApproval'})
      } else {
        next()
      }
    }
  },
  {
    path: '/',
    component: Navbar,
    children: [
      { name: 'profile', path: '/profile', component: Profile },
      // { path: '/pending-offers', component: OffersDetailComponent },
      // { path: '/pending-offers/:collection_id', component: CollectionComponent },
      // { path: '/pending-offers/:collection_id/:offer_id', component: OffersComponent },
      { name: 'selectPendingOffers', path: '/pending-offers/offer-select', component: OffersComponent },
      { name: 'selectPastOffers', path: '/past-offers/offer-select', component: OffersComponent },
      { name: 'selectedPendingOffers', path: '/pending-offers/selected-offers', component: SelectedOffersList },
      { name: 'selectedPastOffers', path: '/past-offers/selected-offers', component: SelectedOffersList },
      { name: 'PendingApproval', path: '/pending-offers', component: PendingApproval },
      // { path: '/past-offers', component: OffersDetailComponent },
      // { path: '/past-offers/:collection_id', component: CollectionComponent },
      { name: 'PastOffers', path: '/past-offers', component: PastApproval },
      { name: 'FileUpload', path: '/file-upload', component: FileUpload },
      { name: 'PastOffersSpecific', path: '/past-offers/:collection_id/:offer_id', component: OffersComponent },
      { name: 'graph-simulation-navbar',
        path: '/chart-graph-simulation',
        component: GraphSimulationNavBar,
        children: [
          { path: 'past-trends', component: PastTrends, name: 'past-trends' },
          { path: 'waterfall', component: Waterfall, name: 'waterfall' },
          { path: 'simulation', component: Simulation, name: 'simulation' }
        ]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/routes.js